<div class="header">
  <h3>{{ 'developer.webhook.webhooks' | translate }}</h3>
  <div
    class="button button-green"
    (click)="openWebhookModalPopup('New', webhookModal)"
    tabindex="0"
    (keydown.enter)="openWebhookModalPopup('New', webhookModal)"
  >
    <span class="material-symbols-outlined">&#xeb92;</span>
    {{ 'developer.webhook.addWebhook' | translate }}
  </div>
</div>

<!-- Add Webhook Modal -->
<ng-template #webhookModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">
      {{ modalTitle }} {{ 'developer.webhook.webhookEndpoint' | translate }}
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
      tabindex="0"
      (keydown.enter)="modal.dismiss()"
    ></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="addWebhookForm">
      <div class="input-container">
        <label for="inputUrl"
          ><span class="required">*</span> {{ 'developer.webhook.url' | translate }}</label
        >
        <textarea
          id="inputUrl"
          class="mt-1 w-100 url-textarea"
          formControlName="WebhookURL"
          placeholder="https://"
          rows="1"
        ></textarea>
        <span class="error-text">{{ addWebhookFormErrors.WebhookURL }}</span>
      </div>
      <div class="input-container">
        <label><span class="required">*</span> {{ 'developer.webhook.modules' | translate }}</label>
        <div class="dropdown" ngbDropdown placement="top-start">
          <div
            class="input-button"
            role="button"
            ngbDropdownToggle
            (keydown)="onKeyDown($event)"
            tabindex="0"
          >
            <span class="selected-modules">
              * {{ getSelectedModuleNames() || 'Select Modules' }}
            </span>
            <span class="material-symbols-outlined chevron">&#xe313;</span>
          </div>
          <div class="dropdown-menu" ngbDropdownMenu>
            <ul>
              @for (item of moduleList; track item) {
                <li class="dropdown-item">
                  <label class="custom-check-container">
                    @if (!disableFinancing || item.name !== 'Premium Finance') {
                      <span class="selectable-option">{{ item?.name }}</span>
                    }
                    <input
                      type="checkbox"
                      formControlName="Modules"
                      (click)="getSelectedModule(item)"
                      tabindex="0"
                      (keydown.enter)="getSelectedModule(item)"
                    />
                    <span class="checkmark"></span>
                  </label>
                </li>
              }
            </ul>
          </div>
        </div>
        <span class="error-text">{{ addWebhookFormErrors.Modules }}</span>
      </div>
      <div class="input-container">
        <label for="version" class="version-label"
          >{{ 'developer.webhook.version' | translate }}
          <ng-template #tipContent>
            <span [innerHTML]="'developer.webhook.versionMessage' | translate"></span
          ></ng-template>
          @if (this.showVersionTooltip) {
            <img
              src="../../../../../../../assets/images/Warning.svg"
              alt="Only Version 1 is available for all selected modules"
              placement="top"
              [ngbTooltip]="tipContent"
              tooltipClass="custom-tooltip"
            />
          }
        </label>
        <select
          id="version"
          #versionSelect
          formControlName="Version"
          (change)="onVersionSelect(versionSelect.value)"
        >
          @for (version of versions; track version) {
            <option value="{{ version }}">{{ version }}</option>
          }
        </select>
        @if (selectVersionFlag) {
          <span class="error-text">{{ 'developer.webhook.versionErrorMsg' | translate }}</span>
        }
      </div>
      <div class="input-container">
        <label for="authType"
          ><span class="required">*</span> {{ 'developer.webhook.authTypes' | translate }}</label
        >
        <select id="authType" #authType (change)="getSelectedAuthType(+authType.value)">
          @for (item of authenticationTypes; track $index; let i = $index) {
            <option [value]="i">{{ item.name }}</option>
          }
        </select>
      </div>
      @if (getCurrAuthType?.value === 'ApiKey') {
        <div class="input-container">
          <label for="userName"
            ><span class="required">*</span> {{ 'developer.webhook.key' | translate }}</label
          >
          <input type="text" id="key" formControlName="Key" />
          <span class="error-text">{{ addWebhookFormErrors.Key }}</span>
        </div>
      }
      @if (getCurrAuthType?.value === 'ApiKey') {
        <div class="input-container">
          <label for="userName"
            ><span class="required">*</span> {{ 'developer.webhook.value' | translate }}</label
          >
          <input type="text" id="value" formControlName="Value" />
          <span class="error-text">{{ addWebhookFormErrors.Value }}</span>
        </div>
      }
      @if (getCurrAuthType?.value === 'BearerToken') {
        <div class="input-container">
          <label for="userName"
            ><span class="required">*</span> {{ 'developer.webhook.url' | translate }}</label
          >
          <input type="text" id="url" formControlName="URL" />
          <span class="error-text">{{ addWebhookFormErrors.URL }}</span>
        </div>
      }
      @if (getCurrAuthType?.value === 'BasicAuth' || getCurrAuthType?.value === 'BearerToken') {
        <div class="input-container">
          <label for="userName"
            ><span class="required">*</span> {{ 'common.userName' | translate }}</label
          >
          <input type="email" id="userName" formControlName="Username" />
          <span class="error-text">{{ addWebhookFormErrors.Username }}</span>
        </div>
      }
      @if (getCurrAuthType?.value === 'BasicAuth' || getCurrAuthType?.value === 'BearerToken') {
        <div class="input-container">
          <label for="password"
            ><span class="required">*</span> {{ 'common.password' | translate }}</label
          >
          <input type="email" id="password" formControlName="Password" />
          <span class="error-text">{{ addWebhookFormErrors.Password }}</span>
        </div>
      }
      @if (getCurrAuthType?.value === 'BearerToken') {
        <div class="input-container">
          <label for="bearerToken"
            ><span class="required">*</span> {{ 'developer.webhook.response' | translate }}</label
          >
          <input type="text" id="bearerToken" formControlName="Response" />
          <span class="error-text">{{ addWebhookFormErrors.Response }}</span>
        </div>
      }
      <div class="input-container">
        <label for="hmacKey">{{ 'developer.webhook.hmacKey' | translate }}</label>
        <input
          type="text"
          id="hmacKey"
          formControlName="HmacKey"
          (input)="onInputChangeEvent($event)"
          placeholder="HEX Encoded"
        />
        <span class="error-text">{{ addWebhookFormErrors.HmacKey }}</span>
      </div>
      @if (showHmacKeyBase64Field) {
        <div class="input-container">
          <label>{{ 'developer.webhook.hmacKeyEncoded' | translate }}</label>
          <p class="encoded-key">{{ hmacKeyBase64 }}</p>
        </div>
      }
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      #closeAddModal
      class="button button-clear"
      (click)="modal.close()"
      tabindex="0"
      (keydown.enter)="modal.close()"
    >
      {{ 'common.cancel' | translate }}
    </button>
    <button
      type="button"
      class="button button-pink"
      (click)="addWebhook()"
      tabindex="0"
      (keydown.enter)="addWebhook()"
      [style]="isLoader_addWebhook() ? 'pointer-events: none; cursor: not-allowed;' : ''"
    >
      <span>
        @if (isLoader_addWebhook()) {
          <span class="spinner-border spinner-border-sm"></span>
        }
        <span class="m-3">{{ 'common.save' | translate }}</span>
      </span>
    </button>
  </div>
</ng-template>

<!-- Table Component -->
<app-table></app-table>
